module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_reason01-b0cc0df768b7e6ccfa197fb49f20a029.png";